import { Prisma } from "./generated/prisma-client";

let client: Prisma = null
//@ts-ignore
if (!process.browser) {
	const { prisma } = require("./generated/prisma-client");
	client = prisma;
}

export default client